import type { ApiEndpointBuilder } from "../apiEndpointHelpers";
import { buildAdminV2GrowthCampaignsEndpoints } from "./adminV2GrowthCampaignEndpoints";
import { buildAdminV2GrowthFormsEndpoints } from "./adminV2GrowthFormEndpoints";
import { buildAdminV2GrowthFormSubmissionsEndpoints } from "./adminV2GrowthFormSubmissionEndpoints";
import { buildAdminV2GrowthSegmentsEndpoints } from "./adminV2GrowthSegmentEndpoints";
import { buildAdminV2GrowthSequencesEndpoints } from "./adminV2GrowthSequenceEndpoints";
import { buildAdminV2GrowthTagsEndpoints } from "./adminV2GrowthTagEndpoints";

/**
 * Composes the focused Growth endpoint groups into the shared RTK Query API.
 * Each child owns one Growth capability while this module preserves the
 * historical builder export consumed by baseApi.
 */
export const buildAdminV2GrowthEndpoints = (builder: ApiEndpointBuilder) => ({
  ...buildAdminV2GrowthFormsEndpoints(builder),
  ...buildAdminV2GrowthFormSubmissionsEndpoints(builder),
  ...buildAdminV2GrowthTagsEndpoints(builder),
  ...buildAdminV2GrowthSegmentsEndpoints(builder),
  ...buildAdminV2GrowthCampaignsEndpoints(builder),
  ...buildAdminV2GrowthSequencesEndpoints(builder),
});
